import request from '@/utils/request'

const payApiUrl = process.env.VUE_APP_PAY_API

// 异常保证金分页
export function getAbnormalGuaranteePageApi(data) {
  return request(
    {
      url: payApiUrl + '/v1/depositReceiptEntry/error/page',
      method: 'post',
      data
    },
    { needLoading: true }
  )
}

// 申请单笔退回保证金
export function applyReturnGuaranteeApi(depositReceiptEntryId) {
  return request(
    {
      url:
        payApiUrl +
        `/v1/depositReceiptEntry/apply/refunt/${depositReceiptEntryId}`,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    { needLoading: true }
  )
}

// 查询账户保证金额度
export function getVipGuaranteeApi(params) {
  return request({
    url: payApiUrl + '/avs/deposit/quota',
    method: 'get',
    params
  })
}

// 查询账户保证金额度使用记录
export function getVipGuaranteeHistoryApi(params) {
  return request({
    url: payApiUrl + '/avs/deposit/quota/page',
    method: 'get',
    params
  })
}
